import { useSelector } from 'react-redux'
import { fromPath } from './../utils'
import { interpolateText } from './interpolator'
import { selectTranslations } from './../store/slices/locale.slice'

export const useTranslate = () => {
  const translations = useSelector(selectTranslations)

  const t = (path: string, data?: any): string => {
    return interpolateText(fromPath(translations, path), data)
  }

  return { t }
}
